export default {"src":"/_next/static/media/profile-weakness.f83143d2.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};